export default (theme) => ({
  signOutButton: { },
});



// WEBPACK FOOTER //
// ./src/components/OAuthSignOutButton/styles.js